var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"violations-modal"},[_c('r-title',[_vm._v(_vm._s(_vm.title))]),_c('modal-copy',{attrs:{"source_id":_vm.sourceId,"source":_vm.source,"copy-source":_vm.copySource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }